import { fadeOut } from '@hellodarwin/core/lib/theme/keyframes';
import styled, { css } from 'styled-components';

interface ChecklistDropdownContainerProps {
  $isMobile: boolean;
  $fadeOut?: boolean;
  onAnimationEnd?: () => void;
}

export const ChecklistDropdownContainer = styled.div<ChecklistDropdownContainerProps>`
  box-sizing: border-box;
  width: ${({ $isMobile }) => (!$isMobile ? 'fit-content' : '100%')};
  display: flex;
  justify-content: flex-end;
  background: ${({ theme, $isMobile }) =>
    !$isMobile ? 'transparent' : theme.colors.white_1};
  border-bottom: ${({ theme, $isMobile }) =>
    !$isMobile ? 'none' : `1px solid ${theme.colors.grey_4}`};

  position: ${({ $isMobile }) => (!$isMobile ? 'fixed' : 'static')};
  top: ${({ theme, $isMobile }) =>
    !$isMobile ? `${theme.appearance.appHeaderHeight}px` : 'auto'};
  right: ${({ $isMobile }) => (!$isMobile ? '0' : 'auto')};
  z-index: 999;

  ${({ $fadeOut }) =>
    $fadeOut &&
    css`
      animation: ${fadeOut} 1000ms ease-out forwards;
    `}
`;

export const ChecklistDropdownHeader = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;

export const ChecklistDropdownBody = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.md}px;
  padding-top: 0;
`;
